import { actions } from "@/redux/reducers/TableFilter";
import { RootState } from "@/redux/store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const FilterStateStoreAutoClearer = () => { // NOSONAR
	const dispatch = useDispatch();

	const locationId = useSelector((state: RootState) => state.location.location?.locationId ?? "");
	const { pathname } = useLocation();

	useEffect(() => {
		dispatch(actions.DELETE_MULTIPLE_FILTERS("locationChange"));
	}, [locationId]);

	useEffect(() => {
		dispatch(actions.DELETE_MULTIPLE_FILTERS("routeChange"));
	}, [pathname]);

	return null;
};
